import { render } from "./ViewPhoto.vue?vue&type=template&id=39e64570&scoped=true"
import script from "./ViewPhoto.vue?vue&type=script&lang=js"
export * from "./ViewPhoto.vue?vue&type=script&lang=js"

import "./ViewPhoto.vue?vue&type=style&index=0&id=39e64570&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e64570"]])

export default __exports__